import { apiClient } from './api-client'
import type { AgendaRequest } from '@/types/tasks'
import type { BoardView, TaskStage, TaskView } from '@/lib/tasks-board'

export interface BoardPage {
  vista: BoardView
  hoje: string
  tarefas: TaskView[]
  truncado: boolean
}

export interface Carteira {
  id: string
  nome: string
  ativo: boolean
  membros: Array<{ id: string; nome: string }>
}

export interface WaitingInput {
  waiting_on: string
  waiting_for: string
  waiting_until: string
}

/** Rotas v2 das tarefas: vistas, etapa, reabrir, agenda e carteiras. */
class TaskBoardService {
  async painel(params: Record<string, string>): Promise<BoardPage> {
    const response = await apiClient.get('/api/tasks/painel', { params })
    return response.data.data
  }

  async get(id: number): Promise<TaskView> {
    const response = await apiClient.get(`/api/tasks/${id}`)
    return response.data.data.task
  }

  async moveStage(id: number, etapa: TaskStage, waiting?: WaitingInput): Promise<{ task: TaskView; enviada_para_revisao: boolean }> {
    const response = await apiClient.post(`/api/tasks/${id}/stage`, { etapa, ...(waiting ?? {}) })
    return response.data.data
  }

  async reopen(id: number): Promise<TaskView> {
    const response = await apiClient.post(`/api/tasks/${id}/reopen`)
    return response.data.data.task
  }

  async requestAgenda(id: number, agenda: AgendaRequest): Promise<void> {
    await apiClient.post(`/api/tasks/${id}/agenda`, agenda)
  }

  async listCarteiras(): Promise<Carteira[]> {
    const response = await apiClient.get('/api/tasks/carteiras')
    return response.data.data.carteiras
  }

  async createCarteira(input: { nome: string; membros: string[] }): Promise<Carteira> {
    const response = await apiClient.post('/api/tasks/carteiras', input)
    return response.data.data.carteira
  }

  async updateCarteira(id: string, input: { nome?: string; membros?: string[]; ativo?: boolean }): Promise<Carteira> {
    const response = await apiClient.put(`/api/tasks/carteiras/${id}`, input)
    return response.data.data.carteira
  }
}

export const taskBoardService = new TaskBoardService()
